<script setup name="transferAdditional">
import {useTaxStore} from '@/store/modules/tax.js'
import {answer, answerColumn} from '../config.js'
import {storeToRefs} from 'pinia';
import {ElMessage, ElMessageBox} from 'element-plus'
import {cloneDeep} from 'lodash';

const tableRef = ref(null)
const taxStore = useTaxStore()
const {personCollectionList, answer: answerList, transferAdditionalList} = storeToRefs(taxStore);
const tableData = ref([])
const genTableList = () => {
  tableData.value = []
  personCollectionList.value.forEach(item => {
    let res = {
      employeesNo: item.employeesNo,
      name: item.name,
      certificateType: item.certificateType,
      idNumber: item.idNumber,
      CumulativeChildEducation: null,
      CumulativeContinuingEducation: null,
      AccumulatedHousingLoanInterest: null,
      AccumulatedHousingRent: null,
      SupportTheElderlyCumulatively: null,
      AccumulatedInfantChild: null,
      CumulativeInfantCare: null
    }
    let obj = transferAdditionalList.value.find(it => it.idNumber == item.idNumber)
    if (obj) {
      res = {...res, ...item, ...obj}
    }
    tableData.value.push(res)
  })
}
//获取选中
const getSelectionRows = () => {
  let rows = tableRef.value.getSelectionRows();
  return rows
}
const reportHandler = () => {
  let row = getSelectionRows();
  if (row.length == 0) {
    return ElMessage({
      message: '您还没有选中需要报送的人员',
      type: 'warning',
    })
  }
  ElMessageBox.confirm(
      `是否对选中的【${row.length}】条信息进行报送?`,
      '信息',
      {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      }
  )
      .then(() => {
        const ids = row.map(item => item.idNumber)
        tableData.value = tableData.value.map(item => {
          if (ids.includes(item.idNumber)) {
            item = {...item, reportStatus: '报送成功'}
            return item;
          }
        })
        ElMessage({
          message: '报送成功',
          type: 'success',
        })
      })
      .catch(() => {

      })
}
const updateList = ref([]);
const updateVisible = ref(false)
const updateData = () => {
  const ids = tableData.value.map(item => item.idNumber)
  let list = cloneDeep(answerList.value).map(item => {
    if (ids.includes(item.idNumber)) {
      item = {...item}
      return item;
    }
  }).filter(it => it)
  updateList.value = [...list]
  updateVisible.value = true;
}
const updateFJ = () => {
  updateList.value.forEach(el => {
    const index = tableData.value.findIndex(it => el.idNumber === it.idNumber)
    if (index > -1) {
      Object.keys(tableData.value[index]).forEach(key => {
        if (Reflect.has(el, key)) {
          tableData.value[index][key] = el[key]
        }
      })
    }
  });
  updateVisible.value = false;
}
onMounted(() => {
  genTableList()
})
onUnmounted(() => {
  taxStore.setTransferAdditionalList(tableData.value)
})
</script>

<template>
  <div class="wrap">
    <!-- <div class="tip">
        <el-icon color="#409efc" size="18"><WarningFilled /></el-icon>
        <span>只有“报送成功”的纳税人才能进行扣缴申报操作,当前{{tableData.length}}位纳税人（不含非正常）不是该状态，请及时【报送】。</span>
    </div> -->
    <p class="type">
      <span class="title">扣除年度: 2024</span>
    </p>
    <div class="opt-btn">
      <el-space :size="14">
        <!-- <el-button type="primary" >添加</el-button> -->
        <el-button type="primary">导入</el-button>
        <el-button type="primary">删除</el-button>
        <!-- <el-button type="primary" @click="reportHandler">报送</el-button> -->
        <!-- <el-button type="primary">获取反馈</el-button> -->
        <el-button type="primary" @click="updateData">下载更新</el-button>
        <!-- <el-button type="primary">迁入上年数据</el-button> -->
      </el-space>
      <el-space :size="14">
        <el-button type="primary" plain>导出</el-button>
        <el-button type="primary" plain>展开查询条件</el-button>
        <el-dropdown type="primary">
          <el-button type="primary" plain>更多操作</el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>修改</el-dropdown-item>
              <el-dropdown-item>删除</el-dropdown-item>
              <el-dropdown-item>隐藏非正常</el-dropdown-item>
              <el-dropdown-item>异常身份证</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-space>
    </div>
    <el-table
        :data="tableData"
        ref="tableRef"
        style="width: 100%"
        max-height="calc(100vh - 270px)"
        border>
      <el-table-column type="selection" width="55" align="center"/>
      <el-table-column prop="employeesNo" label="工号"/>
      <el-table-column prop="name" label="姓名"/>
      <el-table-column prop="certificateType" label="证件类型"/>
      <el-table-column prop="idNumber" label="证件号码"/>
      <el-table-column prop="CumulativeChildEducation" label="子女教育">
        <template #default="{row}">
          <span v-if="row.CumulativeChildEducation == 2000">2</span>
          <span v-else-if="row.CumulativeChildEducation == 1000">1</span>
          <span v-else>{{ row.CumulativeChildEducation }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="CumulativeContinuingEducation" label="继续教育">
        <template #default="{row}">
          <span v-if="row.CumulativeContinuingEducation == 400">1</span>
          <span v-else>{{ row.CumulativeContinuingEducation }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="AccumulatedHousingLoanInterest" label="住房贷款"/>
      <el-table-column prop="AccumulatedHousingRent" label="住房租金"/>
      <el-table-column prop="SupportTheElderlyCumulatively" label="赡养老人">
        <template #default="{row}">
          <span v-if="row.SupportTheElderlyCumulatively == 3000">1</span>
          <span v-else>{{ row.SupportTheElderlyCumulatively }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="AccumulatedInfantChild" label="婴幼儿照顾费用">
        <template #default="{row}">
          <span v-if="row.AccumulatedInfantChild == 1000">1</span>
          <span v-else-if="row.AccumulatedInfantChild == 2000">2</span>
          <span v-else>{{ row.AccumulatedInfantChild }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="CumulativeInfantCare" label="大病医疗"/>
      <el-table-column label="状态">
        <template #default>
          正常
        </template>
      </el-table-column>
      <el-table-column label="更新时间"/>
    </el-table>
    <el-dialog
        v-model="updateVisible"
        title="下载结果"
        width="800"
    >
      <div>
        <p>
          更新成功，共更新【{{
            updateList.length
          }}】位人员的扣除信息，其中【0】位更新失败，点击保存按钮可以保存本次更新的人员名单</p>
        <el-divider border-style="dashed"/>
        <p>更新成功名单</p>
        <el-divider border-style="dashed"/>
        <div class="d_up_list">
                    <span v-for="(item,index) in updateList" :key="index">
                        {{ item.name }}【居民身份证：{{ item.idNumber }}】
                    </span>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="updateVisible = false">保存</el-button>
          <el-button type="primary" @click="updateFJ">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: 100%;

  :deep(.el-table) {
    --el-table-header-bg-color: #f8f9fa;
  }

  .tip {
    width: 100%;
    height: 38px;
    display: flex;
    align-items: center;
    background: #f0f3f6;
    color: #666;
    padding: 0 6px;
    box-sizing: border-box;
    font-size: 14px;
  }

  .type {
    height: 60px;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    .title {
      height: 20px;
      border-left: 4px solid var(--el-color-primary);
      box-sizing: border-box;
      line-height: 20px;
      text-indent: 12px;
      font-weight: bold;
    }
  }

  .opt-btn {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .d_up_list {
    display: flex;
    flex-direction: column;
  }
}
</style>
